module.exports = __webpack_public_path__ + "img/main.7735f6ea.jpg";